const FLASH_INVADERS_API_URL = 'https://api.space-invaders.com/flashinvaders_v3_pas_trop_predictif/api';

export interface FlashInvaderData {
  name: string;
  image_url: string;
  point: number;
  city_id: number;
  space_id: number;
  date_pos: string;
  date_flash: string;
}

export interface FlashPlayerData {
  name: string;
  email: string;
  score: number;
  rank: number;
  rank_str: string;
  si_found: number;
  city_found: number;
  is_email_validated: boolean;
  registration_date: string;
}

export interface FlashCityData {
  id: number;
  name: string;
  short_name: string;
  si_count: number;
}

export interface FlashInvadersResponse {
  invaders: Record<string, FlashInvaderData>;
  total_si_count: number;
  cities: FlashCityData[];
  player: FlashPlayerData;
  message?: string;
  code?: number;
}

export class FlashInvadersService {
  /**
   * Appelle directement l'API Flash Invaders depuis le navigateur.
   * Contourne le blocage IP des datacenters.
   */
  static async fetchGallery(uuid: string): Promise<FlashInvadersResponse> {
    const response = await fetch(`${FLASH_INVADERS_API_URL}/gallery?uid=${uuid}`);

    if (!response.ok) {
      throw new Error(`Erreur Flash Invaders API: ${response.status}`);
    }

    return await response.json();
  }
}
